
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`::slotted(.hidden-form) {
  display: none;
}
`;
